import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Input,
  VStack,
  Field,
  InputGroup,
  Icon,
  Image,
  Dialog,
  Flex,
  Separator
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import { IMailbox } from '../types';

export interface ICreateMailboxData {
    host: string;
    port?: number;
    email: string;
    password: string;
}

interface CreateMailboxFormProps {
  onSubmit: (formData: ICreateMailboxData, setError: (error: string) => void) => Promise<string>;
  callback: () => void;
  initialValues?: Partial<IMailbox>
}

export default function CreateMailboxForm ({ onSubmit, callback, initialValues = {} }: CreateMailboxFormProps) {
  const [error, setError] = useState<string | null>(null);

  const {
    handleSubmit,
    values,
    handleChange,
    errors,
    touched,
  } = useFormik<ICreateMailboxData>({
    initialValues: {
        host: initialValues.host ?? '',
        port: initialValues.port ?? undefined,
        email: initialValues.email ?? '',
        password: initialValues.password ?? '',
    },
    onSubmit: async (formData) => {
      const res = await onSubmit(formData, setError);
      if (res) return callback()
    },
  });


  return (
      <form onSubmit={handleSubmit} name='create-mailbox-form'>
        <VStack align="stretch" gap={4}>
          <VStack gap={4}>
            <Field.Root invalid={touched.email && Boolean(errors.email)}>
              <Field.Label>IMAP User</Field.Label>
              <Input
                  id="email"
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  required
                  placeholder='Email ID'
                  borderRadius={15}
                  size='lg'
                />

              <Field.ErrorText>{errors.email}</Field.ErrorText>
            </Field.Root>

            <Field.Root invalid={touched.password && Boolean(errors.password)}>
              <Field.Label>IMAP Password</Field.Label>
              <Input
                    id="password"
                    name="password"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    required
                    placeholder='Password'
                    borderRadius={15}
                    size='lg'
                  />

              <Field.ErrorText>{errors.password}</Field.ErrorText>
            </Field.Root>

            <Field.Root invalid={touched.host && Boolean(errors.host)}>
                <Field.Label>IMAP Host</Field.Label>
                <Input
                    id="host"
                    name="host"
                    type="text"
                    value={values.host}
                    onChange={handleChange}
                    required
                    placeholder='imap.gmail.com'
                    borderRadius={15}
                    size='lg'
                />

              <Field.ErrorText>{errors.host}</Field.ErrorText>
            </Field.Root>

            <Field.Root invalid={touched.port && Boolean(errors.port)}>
              <Field.Label>IMAP Port</Field.Label>
              <Input
                    id="port"
                    name="port"
                    type="number"
                    value={values.port}
                    onChange={handleChange}
                    required
                    placeholder='993'
                    borderRadius={15}
                    size='lg'
                  />

              <Field.ErrorText>{errors.port}</Field.ErrorText>
            </Field.Root>
          </VStack>
          <Separator mx={-6} my={2}/>
          <Flex gap={2} my={-2} justifyContent='end'>
              <Button variant="outline" onClick={()=> callback()}>Close</Button>
              <Button colorPalette='brand' type='submit'>Save</Button>
          </Flex>

          {error && (
            <Alert.Root status="error">
              <Alert.Indicator />
              <Alert.Title>{error}</Alert.Title>
            </Alert.Root>
          )}
        </VStack>
      </form>
  );
};
